import React from "react";
import { Avatar, Box, Grid, Typography } from "@mui/material";
import { PersonaStructure } from "@interfaces/response";
import { formatPersonName, getPersonInitials, isPersonInfoComplete } from "@components/PersonForm/personHelpers";

type PersonFormTabsProps = {
  persons: PersonaStructure[];
  selectedPersonId?: string | null;
  onSelectPerson: (personId: string) => void;
};

const PersonFormTabs: React.FC<PersonFormTabsProps> = ({ persons, selectedPersonId, onSelectPerson }) => (
  <Grid container spacing={1.5}>
    {persons.map((person) => {
      const isSelected = selectedPersonId === person.id;
      const isComplete = isPersonInfoComplete(person.personal_information_status);
      const roleLabels = (person.person_types_detail || [])
        .map((personType) => personType.name?.trim())
        .filter(Boolean);

      return (
        <Grid item xs={12} sm={6} md={4} key={person.id}>
          <Box
            component="button"
            type="button"
            onClick={() => onSelectPerson(person.id)}
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "flex-start",
              gap: 1.5,
              p: 1.5,
              borderRadius: 2,
              border: "2px solid",
              borderColor: isSelected ? "secondary.main" : "transparent",
              bgcolor: "background.paper",
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
              cursor: "pointer",
              textAlign: "left",
              position: "relative",
              font: "inherit",
              "&:hover": {
                bgcolor: "grey.50",
                borderColor: isSelected ? "secondary.main" : "secondary.light",
              },
            }}
          >
            <Avatar
              sx={{
                width: 40,
                height: 40,
                fontSize: 14,
                fontWeight: 700,
                bgcolor: isSelected ? "primary.main" : "grey.300",
                color: isSelected ? "primary.contrastText" : "primary.dark",
                flexShrink: 0,
              }}
            >
              {getPersonInitials(person)}
            </Avatar>

            <Box flex={1} minWidth={0} pr={1}>
              <Typography
                variant="body2"
                color="primary.dark"
                fontWeight={700}
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {formatPersonName(person)}
              </Typography>

              <Typography
                variant="caption"
                color="primary.main"
                sx={{
                  display: "block",
                  mt: 0.25,
                  lineHeight: 1.3,
                  wordBreak: "break-word",
                }}
              >
                {roleLabels.length > 0 ? roleLabels.join(" · ") : "Sin tipos asignados"}
              </Typography>
            </Box>

            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                bgcolor: isComplete ? "success.main" : "warning.main",
                position: "absolute",
                top: 10,
                right: 10,
                flexShrink: 0,
              }}
            />
          </Box>
        </Grid>
      );
    })}
  </Grid>
);

export default PersonFormTabs;
